<script lang="ts">
    import { _ } from "svelte-i18n"
    import {
        convertFileToBase64,
        cryptchaSolution,
        cryptchaSolutionId,
        filesize,
        initCryptcha,
        resetCryptcha,
    } from "../../../utils"

    import FormInputText from "../../widgets/FormInputText.svelte"
    import TrashCan from "svelte-material-icons/TrashCan.svelte"
    import { postContactForm } from "../../../api"
    import MiniLoader from "../../widgets/MiniLoader.svelte"
    import { onMount } from "svelte"
    import { setUser } from "../../../sentry"

    let loading = false
    let finished = false
    let error: any

    let _files: FileList
    let formData: {
        files: {
            title: string
            file: {
                rawFile?: File
                src?: string
                path?: string
                type?: string
                size?: number
            }
        }[]
        [key: string]: any
    } = {
        firstname: "",
        lastname: "",
        email: "",
        phone: "",
        street: "",
        houseNumber: "",
        city: "",
        postcode: "",
        subject: "",
        message: "",
        files: [],
        _s: "",
    }

    $: if (_files?.length) {
        console.log(_files)
        for (let i = 0; i < _files.length; i++) {
            formData.files.push({
                title: "",
                file: {
                    rawFile: _files[i],
                },
            })
        }

        _files = null
        formData.files = formData.files
    }

    let x = ""

    const submit = async () => {
        loading = true
        try {
            // transform files
            for (let i = 0; i < formData.files.length; i++) {
                const f = formData.files[i]
                f.file.src = await convertFileToBase64(f.file.rawFile)
                // @ts-ignore
                f.file.path = f.file.rawFile.path || f.file.rawFile.name
                f.file.type = f.file.rawFile.type
                f.file.size = f.file.rawFile.size
                delete f.file.rawFile
            }

            formData._s = $cryptchaSolution
            formData._sId = $cryptchaSolutionId

            console.log(formData)

            // track to sentry
            setUser({
                email: formData.email,
            })

            let response = await postContactForm(
                formData,
                (((formData.email?.length as number) || 1) * 1000).toString(16) + x
            )
            formData.files = []
            console.log(response)
            finished = true
        } catch (e) {
            console.log(e)
            error = e
        }
        loading = false
        resetCryptcha()
    }

    typeof window !== "undefined" &&
        window.setTimeout(() => {
            x = "x"
        }, 5000)

    let cryptchaEl: HTMLElement
    onMount(() => {
        initCryptcha(cryptchaEl)
    })

    // throw new Error("test")
</script>

{#if loading}
    <MiniLoader />
{:else if finished}
    <b>{$_("contact-form.success")}</b>
{:else if error}
    <b style="color: var(--error);">{$_("contact-form.error")}</b>
{:else}
    <form
        class="form"
        on:submit|preventDefault="{() => {
            submit()
        }}"
    >
        <div class="row">
            <div class="col-md-4">
                <FormInputText
                    name="vorname"
                    placeholder="{$_('contact-form.firstname')} ({$_('contact-form.optional')})"
                    type="text"
                    bind:value="{formData.firstname}"
                />
            </div>
            <div class="col-md-4">
                <FormInputText
                    name="nachname"
                    placeholder="{$_('contact-form.lastname')} ({$_('contact-form.optional')})"
                    type="text"
                    bind:value="{formData.lastname}"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <FormInputText
                    name="email"
                    placeholder="{$_('contact-form.email')}*"
                    type="email"
                    required
                    bind:value="{formData.email}"
                />
            </div>
            <div class="col-md-4">
                <FormInputText
                    name="phone"
                    placeholder="{$_('contact-form.phone')} ({$_('contact-form.optional')})"
                    type="tel"
                    bind:value="{formData.phone}"
                />
            </div>
        </div>
        <div class="row">
            <br />
        </div>
        <div class="row">
            <div class="col-md-8">
                <FormInputText
                    name="street"
                    placeholder="{$_('contact-form.street')}*"
                    type="text"
                    required
                    bind:value="{formData.street}"
                />
            </div>
            <div class="col-md-4">
                <FormInputText
                    name="houseNumber"
                    placeholder="{$_('contact-form.house-number')}*"
                    type="text"
                    required
                    bind:value="{formData.houseNumber}"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <FormInputText
                    name="postcode"
                    placeholder="{$_('contact-form.postcode')}*"
                    type="text"
                    required
                    bind:value="{formData.postcode}"
                />
            </div>
            <div class="col-md-4">
                <FormInputText
                    name="city"
                    placeholder="{$_('contact-form.city')}*"
                    type="text"
                    required
                    bind:value="{formData.city}"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <FormInputText
                    name="betreff"
                    placeholder="{$_('contact-form.subject')}*"
                    type="text"
                    required
                    bind:value="{formData.subject}"
                />
            </div>
            <div class="col-md-12">
                <textarea
                    name="nachricht"
                    rows="5"
                    placeholder="{$_('contact-form.message')}*"
                    required
                    bind:value="{formData.message}"></textarea>
            </div>
            <div class="col-md-12">
                <!-- TODO  noch austauschen durch Checkbox Widget! -->
                <input type="checkbox" name="dsgvo" required />
                <span>
                    {@html $_("contact-form.privacy-terms-checkbox-html")}
                </span>
            </div>
            <div class="col-md-12">
                <label for="upload">{$_("contact-form.file-upload")}</label>
                <input type="file" name="upload" bind:files="{_files}" multiple />
                {#each formData.files as f, idx}
                    <div style="padding-bottom:8px;">
                        <!-- svelte-ignore a11y-invalid-attribute -->
                        <a
                            href=""
                            style="padding: 8px;"
                            on:click|preventDefault="{() => {
                                formData.files.splice(idx, 1)
                                formData.files = formData.files
                            }}"><TrashCan /></a
                        >
                        {f.file.rawFile?.name}
                        ({filesize(f.file.rawFile?.size)})<br />
                    </div>
                {/each}
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <button class="btn btn-secondary" type="submit" disabled="{!$cryptchaSolution}"
                    >{$_("contact-form.send")}</button
                >
            </div>
            <div class="col-md-8" bind:this="{cryptchaEl}"></div>
        </div>
    </form>
{/if}

<style lang="less">
    @import "../../../css/variables.less";

    .form {
        max-width: 800px;
    }
</style>
